import { useTranslation } from 'react-i18next';
import { useUserDataStore } from '../../../shared_stores';
import { Button } from '@mantine/core';
import EmojiEventsOutlinedIcon from '@mui/icons-material/EmojiEventsOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import classes from '../../../app.module.css';
import { useNavigate } from 'react-router-dom';

export const GoalsWidget = () => {
  const { t } = useTranslation(['common', 'reports']);
  const navigate = useNavigate();
  const userDataStore = useUserDataStore();

  return (
    <Button
      variant="widget"
      fullWidth
      leftSection={<EmojiEventsOutlinedIcon />}
      rightSection={<SettingsOutlinedIcon />}
      classNames={{
        inner: classes.flexStartButtonInner,
        label: classes.flexGrowButtonLabel,
      }}
      onClick={() => void navigate('/dashboard/goal')}
    >
      <b>{t('reports:goal')}:&nbsp;</b>
      {t(`reports:${userDataStore.userGoal?.name}`)}
    </Button>
  );
};
